import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';

export const RootContainer = styled(Box)({
  border: '1px solid #ccc',
  borderRadius: '8px',
  padding: '12px',
  width: '100%',
  backgroundColor: '#E7E7E7',
  marginBottom: '15px',
});

export const AccordionContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const StyledTitle = styled(Typography)({
  fontWeight: 600,
  color: '#155097',
});

export const AnswerContainer = styled(Box)({
  paddingTop: '16px',
  borderTop: '1px solid #eee',
});

export const StyledList = styled(List)({
  listStyle: 'decimal',
  paddingLeft: '64px',
  marginTop: '10px',
  marginBottom: '10px',
  paddingTop: 0,
  paddinBottom: 0,
});
